var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden",
        },
      ],
      staticClass: "input grid__cell",
      class: _vm.inputClasses,
    },
    [
      _c("div", { staticClass: "input--textArea" }, [
        _c(
          "p",
          {
            staticClass: "text-small-bold black mg mg--b-2",
            class: { inputIsFocused: _vm.inputHasFocus },
          },
          [_vm._v(_vm._s(_vm.$t(_vm.literal)))]
        ),
        _c("div", { staticClass: "input__wrapper" }, [
          _c("textarea", {
            attrs: {
              name: _vm.name,
              type: _vm.type,
              disabled: _vm.disabled,
              placeholder: _vm.placeholderTxt,
              maxlength: "255",
            },
            domProps: { value: _vm.value },
            on: {
              change: function ($event) {
                return _vm.$emit("change", $event.target.value)
              },
              input: function ($event) {
                return _vm.$emit("input", $event.target.value)
              },
              focus: function ($event) {
                _vm.inputHasFocus = true
              },
              blur: function ($event) {
                _vm.inputHasFocus = false
              },
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }